import { mutation } from "@api/graphql.js";
import sendNewsletterApplicationMutation from "@api/mutations/sendNewsletterApplication.graphql";
import type { NewsletterApplicationInput } from "@core/schema/NewsletterApplication.js";

export async function subscribeToNewsletter(endpoint: string, input: NewsletterApplicationInput): Promise<void> {
	await mutation<boolean, { input: NewsletterApplicationInput }>(endpoint, sendNewsletterApplicationMutation, {
		input,
	});
}
